import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';
import { ESTATUS_AUTORIZADO } from 'utils/constants';

export const baseURI = '/contabilidad/cuentas-contables';
export const baseURI2 = '/catalogos/clasificaciones-de-cuentas-contables/';
export const baseURI3 = '/catalogos/tipos-de-cuentas-contables/';
export const baseURI4 = '/catalogos/naturalezas-de-ingreso/';
export const baseURI5 = '/catalogos/momentos-presupuestales-de-egresos/';
export const baseURI6 = '/catalogos/momentos-presupuestales-de-ingresos/';
export const baseURI7 = '/catalogos/afectaciones-presupuestales/';

/**
 * GET Tipos de Seguridad Social
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCuentasContables = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};
export const getCuentasContablesNaturaleza = async (params) => {
  try {
    const response = await API.get(baseURI4, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getCuentasContablesEgresos = async (params) => {
  try {
    const response = await API.get(baseURI5, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getCuentasContablesIngresos = async (params) => {
  try {
    const response = await API.get(baseURI6, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getCuentasContablesAfeccionesPresupuestales = async (params) => {
  try {
    const response = await API.get(baseURI7, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipos de Seguridad Social
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCuentasContablesClasificador = async (params) => {
  try {
    const response = await API.get(baseURI2, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipos de Seguridad Social
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCuentasContablestipos = async (params) => {
  try {
    const response = await API.get(baseURI3, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Tipo de Seguridad Social
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getCuentaContable = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo de Seguridad Social
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCuentaContable = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Seguridad Social
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCuentaContable = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Seguridad Social
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteCuentasContable = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * AUTORIZAR Nivel de Estudio
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const autorizarCuentasContable = async (id) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, { estados_globales: ESTATUS_AUTORIZADO });
    onSuccess(response, 'Autorizado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
